import { Uuid } from "types"

export const PriceNomenclatureFiltersCell = ({
    value,
}: {
    value: Array<{ name: string; id: Uuid }>
}) => {
    return <span>{value.map((el) => el.name).join("; ")}</span>
}
